import {OtsDateTime} from "../components/OtsDateTime";
import type {WellAllocationConfiguration} from "@ots-frontend/ots-data";

export type AllocationCalculationSummaryProps = {configuration: WellAllocationConfiguration; eligibleWellCount: number};

const labels: Record<string, string> = {
  RETROSPECTIVE: "Retrospective",
  WEEKLY: "Weekly",
  PER_SITE: "All wells at site",
  TICKET_WELL: "Ticket well",
  CONTAINER_WELLS: "Wells linked to container",
  DISABLED: "Disabled",
};


/** Resolved configuration and ordered calculation explanation for an allocation result. */
export const AllocationCalculationSummary = ({configuration, eligibleWellCount}: AllocationCalculationSummaryProps) => {
  const group = configuration.timeGroup.toLowerCase().replace("_", " ");
  return (
    <section className="rounded-xl border border-[var(--ots-outline-variant)] bg-[var(--ots-surface)] p-4 sm:p-5">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div><div className="text-xs font-semibold uppercase tracking-wide text-[var(--ots-text-muted)]">Calculation</div><div className="mt-1 font-semibold text-[var(--ots-text)]">{labels[configuration.allocationType]}</div></div>
        <div><div className="text-xs font-semibold uppercase tracking-wide text-[var(--ots-text-muted)]">Eligible wells</div><div className="mt-1 font-semibold text-[var(--ots-text)]">{labels[configuration.eligibilityMethod]} · {eligibleWellCount}</div></div>
        <div><div className="text-xs font-semibold uppercase tracking-wide text-[var(--ots-text-muted)]">Configured window</div><div className="mt-1 font-semibold text-[var(--ots-text)]">{configuration.chunkCount} {group} {configuration.chunkCount === 1 ? "chunk" : "chunks"}</div></div>
        <div><div className="text-xs font-semibold uppercase tracking-wide text-[var(--ots-text-muted)]">Week begins</div><div className="mt-1 font-semibold capitalize text-[var(--ots-text)]">{configuration.weekStartsOn.toLowerCase()}</div></div>
      </div>

      <div className="mt-5 rounded-lg bg-[var(--ots-primary-container)] px-4 py-3 text-sm text-[var(--ots-secondary)]">
        <span className="font-semibold">Production window:</span>{" "}
        <OtsDateTime value={configuration.windowStartDttm} timeZone={configuration.timeZone} /> through <OtsDateTime value={configuration.windowEndDttm} timeZone={configuration.timeZone} />
        <span className="text-[var(--ots-text-muted)]"> (end exclusive, {configuration.timeZone})</span>
      </div>
    </section>
  );
};
